/*
 * EVENICA FORM CONTEXT
 * Author: Michael Reed-Bennet
 */

import { createContext } from 'react';

/* INTERFACE: IFormField
 *  Purpose: Holds individual field information.
 */
export interface IFormField {
    name: string;
    value: string;
    isRequired: boolean;
    validation: IFieldValidation[];
    errors: string[];
    reset: () => void;
    friendly: string;
}

/* INTERFACE: IFieldValidation
 *  Purpose: Generic Interface for taking validation regexes from individual field modules.
 */
export interface IFieldValidation {
    regex: string;
    errorMessage: string;
    isRequiredValidation?: boolean;
    invalidSelection?: string;
}

/* INTERFACE: IFormContext
 *  Purpose: Context interface for use with eve-form and it's child modules.
 */
export interface IFormContext {
    registerField: (fieldData: IFormField) => void;
    updateField: (fieldName: string, fieldValue: string, friendlyName: string) => void;
    fields: Record<string, IFormField>;
}

const fields: Record<string, IFormField> = {};
const _errorMsg = 'Must be used within a provider';

const updateField = (fieldName: string, fieldValue: string, friendlyName: string) => {
    throw Error(_errorMsg);
};
const registerField = (fieldData: IFormField) => {
    throw Error(_errorMsg);
};

export const FormContext = createContext<IFormContext>({ registerField, updateField, fields });

const { Consumer: FormConsumer, Provider: FormProvider } = FormContext;
export { FormConsumer, FormProvider };
